import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import { setProduct } from "../../store/actions";
import { useHistory } from "react-router";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";

const ClaimModal = ({ open, onClose }) => {
  const history = useHistory();

  const language = useSelector((state) => state.store.language);

  const storeCategories = useSelector((state) => state.store.store.categories);
  const categoryFreeProducts = useSelector(
    (state) => state.cart.discounts.category_free
  );
  const themeColor = useSelector((state) => state.store.store.settings.dark);

  const pendingCategories = categoryFreeProducts.filter((c) => c.quantity > 0);

  const [selectedItem, setSelectedItem] = useState(null);
  if (
    pendingCategories.length === 1 &&
    pendingCategories[0].categories.length === 1 &&
    open
  ) {
    const singleCategoryId = pendingCategories[0].categories[0];
    const singleCategory = storeCategories.find(
      (storeCat) => storeCat.id === singleCategoryId
    );
    if (singleCategory) {
      history.replace(`/category/${singleCategory.slug}`);
      onClose();
      return null;
    }
  }

  const handleSelect = () => {
    if (!selectedItem) return;
    if (selectedItem.type === "category") {
      history.replace(`/category/${selectedItem.slug}`);
    }
    onClose();
  };

  const handleRadioChange = (event) => {
    const { type, item } = JSON.parse(event.target.value);
    setSelectedItem({ ...item, type });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {language === "english"
          ? "Select your free products now!"
          : "اختر على منتجاتك المجانية الآن"}
      </DialogTitle>
      <DialogContent>
        <RadioGroup
          value={selectedItem ? JSON.stringify(selectedItem) : ""}
          onChange={handleRadioChange}
        >
          <>
            <h4>
              {language === "english" ? "Free Categories" : "الفئات المجانية"}
            </h4>
            {pendingCategories.map((categoryItem) =>
              categoryItem.categories.map((categoryId) => {
                const cat = storeCategories.find(
                  (storeCat) => storeCat.id === categoryId
                );
                return (
                  cat && (
                    <FormControlLabel
                      key={cat.id}
                      value={JSON.stringify({ type: "category", item: cat })}
                      control={
                        <Radio
                          checkedIcon={
                            <RadioButtonCheckedIcon
                              style={{ color: themeColor }}
                            />
                          }
                          checked={
                            selectedItem ? selectedItem.id == cat.id : false
                          }
                        />
                      }
                      label={language === "english" ? cat.name : cat.ar_name}
                    />
                  )
                );
              })
            )}
          </>
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {language === "english" ? "Close" : "إغلاق"}
        </Button>
        <Button onClick={handleSelect} color="primary" disabled={!selectedItem}>
          {language === "english" ? "Select" : "اختر"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClaimModal;
